<template>
  <div class="listSources">
    <DialogSourceManager ref="dialogSourceManager" />
    <Dialog
      ref="dialogEditarSource"
      id="dialogEditarSource"
      titulo="Editar source"
      tamanho="lg"
    >
      <div class="text-left">
        <label>Nome</label>
        <input
          type="text"
          class="form-control"
          v-model="sourceEditNome"
          @keyup.enter="salvarNome"
          autocomplete="off"
        />
        <div class="sourceMachineInfo" v-if="sourceEditItem">
          <small class="text-secondary">Maquina</small>
          <strong>{{ sourceEditItem.hostname || sourceEditItem.key }}</strong>
        </div>

        <div class="sourceDevices" v-if="sourceEditItem">
          <div class="sourceDeviceTableHeader">
            <div>
              <i class="bi bi-camera-video"></i>
              Video
            </div>
            <div>
              <i class="bi bi-mic"></i>
              Audio vinculado
            </div>
          </div>

          <div
            class="sourceDeviceTableRow"
            v-for="video in videoDevices(sourceEditItem)"
            :key="'edit_video_audio_' + video.id + '_' + video.label"
          >
            <div class="sourceDeviceVideoCell">
              <button
                type="button"
                class="sourceDeviceFavoriteButton"
                v-bind:class="{ sourceDeviceFavoriteActive: isFavoriteDevice(sourceEditItem, 'videos', video) }"
                @click="toggleFavoriteDevice(sourceEditItem, 'videos', video)"
              >
                <span class="sourceFavoriteIcon">
                  {{ isFavoriteDevice(sourceEditItem, "videos", video) ? "★" : "☆" }}
                </span>
              </button>
              <span>{{ video.label || video.id }}</span>
            </div>
            <div>
              <select
                class="form-control form-control-sm sourceAudioSelect"
                :value="linkedAudioId(sourceEditItem, video)"
                @change="salvarAudioVinculado(sourceEditItem, video, $event.target.value)"
              >
                <option value="">Sem audio</option>
                <option
                  v-for="audio in selectableAudioDevices(sourceEditItem)"
                  :key="'edit_audio_option_' + video.id + '_' + audio.id"
                  :value="audio.id"
                >
                  {{ audio.label || audio.id }}
                </option>
              </select>
            </div>
          </div>

          <small
            v-if="videoDevices(sourceEditItem).length == 0"
            class="sourceDeviceEmpty"
          >
            Nenhum video detectado
          </small>

          <small
            class="text-danger"
            v-if="sourceEditItem.devices && sourceEditItem.devices.error"
          >
            {{ sourceEditItem.devices.error }}
          </small>
        </div>
      </div>

      <div slot="rodape" class="sourceEditFooter">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          data-dismiss="modal"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="salvarNome"
        >
          Salvar
        </button>
      </div>
    </Dialog>

    <div class="row" style="margin-bottom: 15px">
      <div class="col col-md-8 offset-md-2">
        <div class="d-flex justify-content-center sourceViewSwitch">
          <button
            type="button"
            class="btn btn-sm"
            v-bind:class="{
              'btn-secondary': viewMode == 'sources',
              'btn-outline-secondary': viewMode !== 'sources',
            }"
            @click="setViewMode('sources')"
            style="margin-right: 10px"
          >
            PC's
          </button>
          <button
            type="button"
            class="btn btn-sm"
            v-bind:class="{
              'btn-danger': viewMode == 'live',
              'btn-outline-danger': viewMode !== 'live',
            }"
            @click="setViewMode('live')"
          >
            Live
          </button>
        </div>

        <div class="d-flex justify-content-center" v-if="viewMode == 'sources'">
          <input
            class="form-control inputPesquisaSources"
            type="text"
            placeholder="Pesquise sources..."
            v-model="filtroTexto"
            @keyup="keyupFiltroTexto"
            autocomplete="off"
          />

          <select
            class="form-control"
            v-model="filtroStatus"
            @change="carregarItens"
            style="max-width: 130px; margin-right: 10px"
          >
            <option value="Todos">Todos</option>
            <option value="online">Online</option>
            <option value="offline">Offline</option>
            <option value="com_eventos">Com eventos</option>
            <option value="sem_eventos">Sem eventos</option>
          </select>

          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="carregarItens"
          >
            Atualizar
          </button>
        </div>
      </div>
    </div>

    <ListSourcesLive v-if="viewMode == 'live'" />

    <div v-if="viewMode == 'sources' && loading && filteredItens.length == 0" class="text-secondary" style="margin-bottom: 15px">
      Carregando...
    </div>

    <div v-if="viewMode == 'sources' && !loading && filteredItens.length == 0" class="text-secondary">
      ------
    </div>

    <div class="row sourceCards" v-if="viewMode == 'sources'">
      <div
        class="col-md-6 col-lg-4 col-sm-12"
        v-for="item in filteredItens"
        :key="item._id || item.key"
      >
        <div
          class="card sourceWidget"
          v-bind:class="{
            sourceOnline: isSourceOnline(item),
            sourceOffline: !isSourceOnline(item),
          }"
        >
          <div class="card-body text-left sourceCardBody">
            <div>
              <div class="d-flex justify-content-between align-items-start sourceCardTop">
                <h6 class="card-title sourceTitle">
                  {{ item.nome || item.hostname || "Source" }}
                </h6>
                <span
                  class="badge"
                  v-bind:class="{
                    'badge-success': isSourceOnline(item),
                    'badge-secondary': !isSourceOnline(item),
                  }"
                >
                  {{ isSourceOnline(item) ? "Online" : "Offline" }}
                </span>
              </div>

              <div class="sourceMain">
                <p class="sourceResumo" title="Maquina">
                  <svg class="sourceMachineIcon" viewBox="0 0 24 24" aria-hidden="true">
                    <rect x="4" y="5" width="16" height="11" rx="2"></rect>
                    <path d="M9 20h6"></path>
                    <path d="M12 16v4"></path>
                    <path d="M8 9h8"></path>
                    <path d="M8 12h5"></path>
                  </svg>
                  <span class="sourceHostName">{{ item.hostname || item.key || "-" }}</span>
                  <small class="sourceLastSeen" v-if="item.lastSeenAt">
                    • visto {{ formatLastSeenAgo(item.lastSeenAt) }}
                  </small>
                </p>
              </div>

              <div class="sourceQuickInfo">
                <div class="sourceMetric sourceMetricIp" title="IP de internet">
                  <span class="sourceMetricIcon">
                    <svg class="sourceSvgIcon" viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="8"></circle>
                      <path d="M4 12h16"></path>
                      <path d="M12 4c2 2.2 3 4.9 3 8s-1 5.8-3 8"></path>
                      <path d="M12 4c-2 2.2-3 4.9-3 8s1 5.8 3 8"></path>
                    </svg>
                  </span>
                  <small>{{ item.internetIp || "-" }}</small>
                </div>
                <div class="sourceMetric" title="Videos">
                  <span class="sourceMetricIcon">
                    <svg class="sourceSvgIcon" viewBox="0 0 24 24" aria-hidden="true">
                      <rect x="4" y="7" width="11" height="10" rx="2"></rect>
                      <path d="M15 10l5-3v10l-5-3z"></path>
                    </svg>
                  </span>
                  <strong>{{ deviceCount(item, "videos") }}</strong>
                </div>
                <div class="sourceMetric" title="Audios">
                  <span class="sourceMetricIcon">
                    <svg class="sourceSvgIcon" viewBox="0 0 24 24" aria-hidden="true">
                      <rect x="9" y="4" width="6" height="10" rx="3"></rect>
                      <path d="M6 11c0 3.3 2.7 6 6 6s6-2.7 6-6"></path>
                      <path d="M12 17v3"></path>
                      <path d="M9 20h6"></path>
                    </svg>
                  </span>
                  <strong>{{ deviceCount(item, "audios") }}</strong>
                </div>
              </div>
            </div>

            <div>
              <div class="sourceCardActions">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary sourceActionButton"
                  @click="editarNome(item)"
                >
                  Editar
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary sourceActionButton"
                  @click="$refs.dialogSourceManager.abrir(item)"
                >
                  Preview
                </button>
              </div>

              <div
                class="sourceFavoriteShortcuts"
                v-if="favoriteVideoDevices(item).length > 0"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-light sourceFavoriteToggle"
                  @click="toggleFavoriteExpanded(item)"
                >
                  <span>
                    Favoritos ({{ favoriteVideoDevices(item).length }})
                  </span>
                  <strong>{{ isFavoriteExpanded(item) ? "Ocultar" : "Mostrar" }}</strong>
                </button>

                <div v-if="isFavoriteExpanded(item)">
                  <button
                    type="button"
                    class="btn btn-sm btn-light sourceFavoriteButton"
                    v-for="device in favoriteVideoDevices(item)"
                    :key="'fav_' + device.id"
                    @click="abrirPreviewFavorito(item, device)"
                  >
                    <i class="bi bi-camera-video"></i>
                    {{ device.label || device.id }}
                  </button>
                </div>
              </div>

              <div class="sourceEventShortcuts">
                <button
                  type="button"
                  class="btn btn-sm btn-light sourceEventToggle"
                  @click="toggleTransmissionExpanded(item)"
                >
                  <span>
                    <span
                      class="sourceEventStatusDot"
                      :class="{
                        sourceEventStatusDotActive: sourceTransmissionCount(item) > 0,
                        sourceEventStatusDotIdle: sourceTransmissionCount(item) == 0,
                      }"
                    ></span>
                    Eventos ({{ sourceTransmissionCount(item) }})
                  </span>
                  <strong>{{ isTransmissionExpanded(item) ? "Ocultar" : "Mostrar" }}</strong>
                </button>

                <div v-if="isTransmissionExpanded(item)">
                  <small
                    v-if="sourceTransmissionCount(item) == 0"
                    class="sourceEventEmpty"
                  >
                    Nenhum evento ativo neste source.
                  </small>
                  <div
                    class="sourceEventCard"
                    v-for="evento in sourceTransmissions(item)"
                    :key="evento.stateKey || (evento.eventoId + '_' + evento.sourceKey)"
                  >
                    <div class="sourceEventCardTop">
                      <div class="sourceEventTitleWrap">
                        <strong>{{ evento.eventLabel || shortEventLabel(evento.eventoId) }}</strong>
                        <small>{{ evento.kind === "preview" ? "Preview" : "Transmissao" }}</small>
                      </div>
                      <div class="sourceEventActions">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-secondary sourceEventRemoteButton"
                          @click="abrirTransmissaoRemotaEvento(evento.eventoId)"
                          title="Abrir transmissao remota"
                        >
                          Remoto
                        </button>
                      </div>
                    </div>
                    <small class="sourceEventDevice">
                      {{ evento.deviceLabel || evento.deviceId || "-" }}
                      / {{ evento.audioLabel || evento.audioId || "Sem audio" }}
                    </small>
                    <div class="sourceEventChannels">
                      <button
                        v-for="canal in normalizedChannels(evento.channels)"
                        :key="(evento.stateKey || evento.eventoId) + '_canal_' + canal"
                        type="button"
                        class="btn btn-sm btn-outline-dark sourceEventChannelButton"
                        @click="abrirEventoCanal(evento.eventoId, canal)"
                      >
                        {{ canal }}
                      </button>
                      <small v-if="normalizedChannels(evento.channels).length == 0" class="text-secondary">
                        Sem canais
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { io } from "socket.io-client";
import { api } from "@/services/api.js";
import DialogSourceManager from "../dialogs/DialogSourceManager.vue";
import Dialog from "../components/Dialog.vue";
import ListSourcesLive from "./ListSourcesLive.vue";

export default {
  name: "ListSources",
  components: { DialogSourceManager, Dialog, ListSourcesLive },
  methods: {
    socketBaseUrl() {
      var apiUrl = process.env.VUE_APP_URL_API || "";

      if (apiUrl.endsWith("/api")) {
        apiUrl = apiUrl.substring(0, apiUrl.length - 4);
      }

      return apiUrl;
    },
    async carregarItens() {
      var filtros = "?_limit=1000&_page=1";

      if (this.filtroTexto.trim() !== "") {
        filtros += "&_all=" + encodeURIComponent(this.filtroTexto.trim());
      }

      this.loading = true;

      try {
        const response = await api.get("/source" + filtros);
        api.valid(response.data, this.$router);

        this.itens = (response.data.itens ? response.data.itens : []).sort(function (a, b) {
          return (a.nome || a.hostname || "").localeCompare(b.nome || b.hostname || "");
        });
      } catch (e) {
        console.log(e);
      }

      this.loading = false;
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      var obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        obj.carregarItens();
      }, 300);
    },
    iniciarAutoRefresh() {
      var obj = this;

      clearInterval(this.timerRefresh);
      this.timerRefresh = setInterval(function () {
        obj.carregarItens();
      }, 20000);
    },
    conectarSocket() {
      this.fecharSocket();

      const token = localStorage.getItem("ckd");

      if (!token) {
        return;
      }

      this.socket = io(this.socketBaseUrl(), {
        auth: {
          role: "manager",
          token,
          sourceKey: "source-list-monitor",
        },
        transports: ["websocket", "polling"],
      });

      this.socket.on("connect", () => {
        this.socketConnected = true;
        this.solicitarEstadoTransmissao();
      });

      this.socket.on("disconnect", () => {
        this.socketConnected = false;
      });

      this.socket.on("connect_error", () => {
        this.socketConnected = false;
      });

      this.socket.on("source:transmit:state", (payload) => {
        this.aplicarEstadoTransmissao(payload || {});
      });

      this.solicitarEstadoTransmissao();
    },
    solicitarEstadoTransmissao() {
      if (!this.socket) {
        return;
      }

      this.socket.emit("source:transmit:state:request", { eventoId: "" });
    },
    aplicarEstadoTransmissao(payload) {
      const states = payload.transmissionStates || {};
      const next = {};

      Object.keys(states).forEach((key) => {
        const item = states[key] || {};

        if (item.active !== true) {
          return;
        }

        next[key] = {
          ...item,
          eventoId: item.eventoId || key,
          stateKey: key,
        };
      });

      this.transmissionStates = next;
    },
    fecharSocket() {
      if (this.socket) {
        this.socket.removeAllListeners();
        this.socket.disconnect();
      }

      this.socket = null;
      this.socketConnected = false;
    },
    deviceCount(item, tipo) {
      if (!item.devices || !item.devices[tipo]) {
        return 0;
      }

      return item.devices[tipo].length;
    },
    videoDevices(item) {
      const devices = item.devices && item.devices.videos ? item.devices.videos : [];
      return devices.slice().sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    audioDevices(item) {
      const devices = item.devices && item.devices.audios ? item.devices.audios : [];
      return devices.slice().sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    selectableAudioDevices(item) {
      return this.audioDevices(item).filter((audio) => audio.id !== "none");
    },
    linkedAudioId(item, video) {
      var links = item.deviceAudioLinks || [];
      var link = links.find((audioLink) => audioLink.videoId == video.id);

      return link ? link.audioId : "";
    },
    async salvarAudioVinculado(item, video, audioId) {
      var audio = this.audioDevices(item).find((audioItem) => audioItem.id == audioId);

      try {
        const response = await api.put(
          "/source/" + encodeURIComponent(item.key) + "/device-audio",
          {
            videoId: video.id,
            videoLabel: video.label || video.id,
            audioId,
            audioLabel: audio ? audio.label || audio.id : "",
          },
        );
        api.valid(response.data, this.$router);

        if (!response.data.erro && response.data.item) {
          this.$set(item, "deviceAudioLinks", response.data.item.deviceAudioLinks || []);
        } else if (response.data.erro) {
          alert("Erro ao salvar: " + (response.data.mensagem || JSON.stringify(response.data)));
        }
      } catch (e) {
        console.log(e);
        alert("Erro ao salvar audio vinculado: " + e.message);
      }
    },
    favoriteDevices(item, tipo) {
      if (!item.favoriteDevices || !item.favoriteDevices[tipo]) {
        return [];
      }

      return item.favoriteDevices[tipo];
    },
    favoriteVideoDevices(item) {
      var favoritos = this.favoriteDevices(item, "videos");
      var videos = item.devices && item.devices.videos ? item.devices.videos : [];

      return favoritos.map((favorito) => {
        var device = videos.find((video) => video.id == favorito.id);
        return device || favorito;
      }).sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    sourceItemKey(item) {
      return item._id || item.key || item.hostname;
    },
    isFavoriteExpanded(item) {
      var key = this.sourceItemKey(item);
      return !!this.favoriteExpandedBySource[key];
    },
    toggleFavoriteExpanded(item) {
      var key = this.sourceItemKey(item);
      var expanded = this.isFavoriteExpanded(item);
      this.$set(this.favoriteExpandedBySource, key, !expanded);
    },
    sourceTransmissions(item) {
      return this.transmissionEventsBySource[item.key] || [];
    },
    sourceTransmissionCount(item) {
      return this.sourceTransmissions(item).length;
    },
    isTransmissionExpanded(item) {
      var key = this.sourceItemKey(item);
      return !!this.transmissionExpandedBySource[key];
    },
    toggleTransmissionExpanded(item) {
      var key = this.sourceItemKey(item);
      var expanded = this.isTransmissionExpanded(item);
      this.$set(this.transmissionExpandedBySource, key, !expanded);
    },
    normalizedChannels(channels) {
      if (!channels || channels.length == 0) {
        return [];
      }

      return channels
        .map((channel) => {
          const value = channel && channel.canal !== undefined ? parseInt(channel.canal) : NaN;
          return Number.isNaN(value) ? null : value;
        })
        .filter((value) => value !== null);
    },
    abrirEventoCanal(eventoId, canal) {
      if (!eventoId || canal === undefined || canal === null) {
        return;
      }

      window.open(
        "/view/" + eventoId + "?view=clean&canal=" + canal,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true,
      );
    },
    abrirTransmissaoRemotaEvento(eventoId) {
      if (!eventoId) {
        return;
      }

      window.open(
        "/transmit-remote/" + eventoId,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=950,height=750",
        true,
      );
    },
    shortEventLabel(eventoId) {
      if (!eventoId) {
        return "Evento";
      }

      const value = eventoId.toString();
      if (value.length <= 10) {
        return value;
      }

      return value.substring(0, 6) + "..." + value.substring(value.length - 4);
    },
    isSourceOnline(item) {
      if (!item || item.status !== "online" || !item.lastSeenAt) {
        return false;
      }

      const lastSeen = new Date(item.lastSeenAt);

      if (Number.isNaN(lastSeen.getTime())) {
        return false;
      }

      const diffMs = Date.now() - lastSeen.getTime();

      return diffMs >= 0 && diffMs <= 2 * 60 * 1000;
    },
    formatLastSeenAgo(value) {
      if (!value) {
        return "-";
      }

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return "-";
      }

      const diffMs = Date.now() - date.getTime();

      if (diffMs < 0) {
        return "agora";
      }

      const diffMin = Math.floor(diffMs / 60000);
      if (diffMin < 1) {
        return "agora";
      }
      if (diffMin < 60) {
        return diffMin + (diffMin == 1 ? " min" : " mins");
      }

      const diffHour = Math.floor(diffMin / 60);
      if (diffHour < 24) {
        return diffHour + (diffHour == 1 ? " hora" : " horas");
      }

      const diffDay = Math.floor(diffHour / 24);
      if (diffDay < 30) {
        return diffDay + (diffDay == 1 ? " dia" : " dias");
      }

      const diffMonth = Math.floor(diffDay / 30);
      if (diffMonth < 12) {
        return diffMonth + (diffMonth == 1 ? " mes" : " meses");
      }

      const diffYear = Math.floor(diffDay / 365);
      return diffYear + (diffYear == 1 ? " ano" : " anos");
    },
    isFavoriteDevice(item, tipo, device) {
      return this.favoriteDevices(item, tipo).some((favorito) => {
        return favorito.id == device.id;
      });
    },
    async toggleFavoriteDevice(item, tipo, device) {
      const favorito = !this.isFavoriteDevice(item, tipo, device);

      try {
        const response = await api.put(
          "/source/" + encodeURIComponent(item.key) + "/favorite-device",
          {
            tipo,
            deviceId: device.id,
            deviceLabel: device.label || device.id,
            favorito,
          },
        );
        api.valid(response.data, this.$router);

        if (!response.data.erro && response.data.item) {
          this.$set(item, "favoriteDevices", response.data.item.favoriteDevices || {});
        }
      } catch (e) {
        console.log(e);
      }
    },
    abrirPreviewFavorito(item, device) {
      this.$refs.dialogSourceManager.abrir(item, device, true);
    },
    editarNome(item) {
      this.sourceEditItem = item;
      this.sourceEditNome = item.nome || item.hostname || "";
      this.$refs.dialogEditarSource.abrir();
    },
    async salvarNome() {
      if (!this.sourceEditItem) {
        return;
      }

      var nome = this.sourceEditNome ? this.sourceEditNome.trim() : "";

      if (nome === "") {
        return;
      }

      try {
        const response = await api.put("/source/" + encodeURIComponent(this.sourceEditItem.key), {
          nome,
        });
        api.valid(response.data, this.$router);

        if (!response.data.erro && response.data.item) {
          this.sourceEditItem.nome = response.data.item.nome;
          this.$refs.dialogEditarSource.fechar();
        }
      } catch (e) {
        console.log(e);
      }
    },
    setViewMode(mode) {
      this.viewMode = mode;

      if (mode == "sources") {
        this.carregarItens();
        this.iniciarAutoRefresh();
      } else {
        clearInterval(this.timerRefresh);
      }
    },
  },
  computed: {
    filteredItens: function () {
      if (this.filtroStatus === "online") {
        return this.itens.filter((item) => this.isSourceOnline(item));
      }

      if (this.filtroStatus === "offline") {
        return this.itens.filter((item) => !this.isSourceOnline(item));
      }

      if (this.filtroStatus === "com_eventos") {
        return this.itens.filter((item) => this.sourceTransmissionCount(item) > 0);
      }

      if (this.filtroStatus === "sem_eventos") {
        return this.itens.filter((item) => this.isSourceOnline(item) && this.sourceTransmissionCount(item) == 0);
      }

      return this.itens;
    },
    transmissionEventsBySource: function () {
      const grouped = {};

      Object.values(this.transmissionStates).forEach((item) => {
        if (!item || !item.sourceKey) {
          return;
        }

        if (!grouped[item.sourceKey]) {
          grouped[item.sourceKey] = [];
        }

        grouped[item.sourceKey].push(item);
      });

      Object.keys(grouped).forEach((key) => {
        grouped[key] = grouped[key].sort((a, b) => {
          const aPreview = a.kind === "preview" ? 0 : 1;
          const bPreview = b.kind === "preview" ? 0 : 1;

          if (aPreview !== bPreview) {
            return aPreview - bPreview;
          }

          const aTime = new Date(a.updatedAt || a.startedAt || 0).getTime();
          const bTime = new Date(b.updatedAt || b.startedAt || 0).getTime();

          if (aTime !== bTime) {
            return bTime - aTime;
          }

          return String(a.eventLabel || a.eventoId || "").localeCompare(
            String(b.eventLabel || b.eventoId || ""),
          );
        });
      });

      return grouped;
    },
  },
  mounted() {
    this.carregarItens();
    this.iniciarAutoRefresh();
    this.conectarSocket();
  },
  beforeDestroy() {
    clearTimeout(this.timerFiltroTexto);
    clearInterval(this.timerRefresh);
    this.fecharSocket();
  },
  data: function () {
    return {
      filtroTexto: "",
      filtroStatus: "online",
      itens: [],
      loading: false,
      timerFiltroTexto: 0,
      timerRefresh: 0,
      socket: null,
      socketConnected: false,
      transmissionStates: {},
      sourceEditItem: null,
      sourceEditNome: "",
      favoriteExpandedBySource: {},
      transmissionExpandedBySource: {},
      viewMode: "sources",
    };
  },
};
</script>

<style>
.listSources {
  margin-top: 10px;
}

.inputPesquisaSources {
  min-width: 260px;
  margin-right: 10px;
}

.sourceViewSwitch {
  margin-bottom: 10px;
}

.sourceCards > div {
  display: flex;
}

.sourceWidget {
  border-radius: 4px;
  margin-bottom: 18px;
  border: 1px solid #dfe3e8;
  border-top: 4px solid #6c757d;
  width: 100%;
  min-height: 210px;
  box-shadow: 0 2px 8px rgba(20, 30, 40, 0.06);
}

.sourceOnline {
  border-top-color: #28a745;
}

.sourceOffline {
  border-top-color: #6c757d;
}

.sourceCardBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 206px;
  padding: 14px;
}

.sourceCardTop {
  margin-bottom: 8px;
}

.sourceMain {
  min-height: 44px;
}

.sourceQuickInfo {
  margin-top: 10px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 58px 58px;
  grid-gap: 6px;
  align-items: center;
}

.sourceMetric {
  background: #f8fafc;
  border: 1px solid #e6edf5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  color: #6c757d;
  min-width: 0;
  min-height: 30px;
  padding: 4px 6px;
}

.sourceQuickInfo small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sourceMetric strong {
  color: #354052;
  font-size: 13px;
  line-height: 1;
}

.sourceMetricIcon {
  background: #e8f0fb;
  border-radius: 50%;
  color: #2f65a7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 22px;
  font-size: 13px;
  margin-right: 5px;
  height: 20px;
  min-width: 22px;
  text-align: center;
}

.sourceSvgIcon {
  fill: none;
  height: 14px;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
  width: 14px;
}

.sourceTitle {
  margin-bottom: 0px;
  overflow-wrap: anywhere;
  font-size: 16px;
  line-height: 1.25;
  padding-right: 8px;
}

.sourceCardActions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8px;
  margin-top: 16px;
}

.sourceActionButton {
  min-height: 32px;
  padding: 4px 8px;
  font-size: 12px;
}

.sourceFavoriteShortcuts {
  border-top: 1px solid #eef0f2;
  margin-top: 12px;
  padding-top: 10px;
}

.sourceEventShortcuts {
  border-top: 1px solid #eef0f2;
  margin-top: 12px;
  padding-top: 10px;
}

.sourceEventStatusDot {
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  margin-right: 6px;
  position: relative;
  top: -1px;
  width: 8px;
}

.sourceEventStatusDotActive {
  background: #28a745;
}

.sourceEventStatusDotIdle {
  background: #98a2ad;
}

.sourceFavoriteToggle,
.sourceEventToggle {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #d9e2ec;
  color: #354052;
  display: flex;
  font-size: 11px;
  justify-content: space-between;
  margin-bottom: 8px;
  width: 100%;
}

.sourceFavoriteToggle strong,
.sourceEventToggle strong {
  color: #2f65a7;
  font-size: 11px;
}

.sourceFavoriteButton {
  border: 1px solid #d9e2ec;
  color: #354052;
  display: block;
  font-size: 11px;
  margin-bottom: 5px;
  max-width: 100%;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.sourceFavoriteButton i {
  color: #2f80ed;
  margin-right: 5px;
}

.sourceEventCard {
  background: #f8fafc;
  border: 1px solid #d9e2ec;
  border-radius: 4px;
  margin-bottom: 6px;
  padding: 8px;
}

.sourceEventCardTop {
  display: flex;
  gap: 8px;
  justify-content: space-between;
}

.sourceEventActions {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sourceEventTitleWrap {
  min-width: 0;
}

.sourceEventTitleWrap strong,
.sourceEventTitleWrap small,
.sourceEventDevice {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sourceEventTitleWrap strong {
  color: #354052;
  font-size: 12px;
}

.sourceEventTitleWrap small,
.sourceEventDevice {
  color: #6c757d;
  font-size: 11px;
}

.sourceEventChannels {
  display: flex;
  flex-wrap: wrap;
  margin-top: 6px;
}

.sourceEventRemoteButton {
  font-size: 10px;
  line-height: 1;
  min-height: 20px;
  padding: 2px 6px;
}

.sourceEventEmpty {
  color: #6c757d;
  display: block;
  font-size: 11px;
  margin-bottom: 6px;
}

.sourceEventChannelButton {
  margin: 1px 4px 1px 0;
  min-width: 30px;
  padding: 0 6px;
}

.sourceResumo {
  align-items: center;
  display: flex;
  margin-bottom: 4px;
  min-width: 0;
  overflow-wrap: anywhere;
  color: #6c757d;
}

.sourceHostName,
.sourceResumo small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sourceHostName {
  min-width: 0;
}

.sourceLastSeen {
  color: #8a9299;
  font-size: 11px;
  margin-left: 6px;
}

.sourceMachineIcon {
  color: #7b8794;
  flex: 0 0 17px;
  fill: none;
  height: 17px;
  margin-right: 6px;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
  width: 17px;
}

.sourceMachineInfo {
  background: #f8fafc;
  border: 1px solid #e6edf5;
  border-radius: 4px;
  margin-top: 8px;
  padding: 8px 10px;
}

.sourceMachineInfo small {
  display: block;
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.sourceMachineInfo strong {
  color: #354052;
  display: block;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.sourceEditFooter {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.sourceDevices {
  margin-top: 10px;
}

.sourceDeviceEmpty {
  color: #8a9299;
}

.sourceDeviceTableHeader,
.sourceDeviceTableRow {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  grid-gap: 8px;
}

.sourceDeviceTableHeader {
  background: #f4f7fb;
  border: 1px solid #e2e8f0;
  border-radius: 6px 6px 0 0;
  color: #52606d;
  font-size: 11px;
  font-weight: 700;
  padding: 7px 8px;
}

.sourceDeviceTableHeader i {
  margin-right: 4px;
}

.sourceDeviceTableRow {
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  padding: 8px;
}

.sourceDeviceTableRow:last-of-type {
  border-radius: 0 0 6px 6px;
}

.sourceDeviceVideoCell {
  display: flex;
  align-items: center;
  min-width: 0;
}

.sourceDeviceVideoCell span {
  color: #354052;
  font-size: 12px;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.sourceDeviceFavoriteButton {
  background: transparent;
  border: 0;
  color: #a9b2bd;
  flex: 0 0 24px;
  font-size: 18px;
  line-height: 22px;
  height: 24px;
  margin-right: 6px;
  padding: 0;
}

.sourceFavoriteIcon {
  display: block;
  font-size: 20px;
  line-height: 22px;
}

.sourceDeviceFavoriteActive {
  color: #f2b705;
}

.sourceAudioSelect {
  font-size: 12px;
  min-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
